import React from 'react';
import styled from '@emotion/styled';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { selectTimelineFramesCount } from '@/redux/selectors/packagingTimelineSelectors';
import { selectPlayerCurrentFrame } from '@/redux/selectors/packagingSelectors';
import { playerSeek } from '@/components/Packaging/utils';
import { SegmentPlayer } from '@accurate-player/accurate-player-segment';

interface Props {
  player: SegmentPlayer;
}

const SeekBar: React.FC<Props> = ({ player }) => {
  const dispatch = useAppDispatch();
  const totalFrames = useAppSelector(selectTimelineFramesCount);
  const currentFrame = useAppSelector(selectPlayerCurrentFrame);

  const handleSeekBarClick: React.MouseEventHandler<HTMLDivElement> = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const newFrame = Math.round((x / rect.width) * totalFrames);

    playerSeek({
      playerApi: player.api,
      frameIndex: newFrame,
      dispatch,
      updateCurrentFrameInStore: true
    });
  };

  return (
    <Wrapper onClick={handleSeekBarClick}>
      <ProgressBarWrapper>
        <ProgressBar style={{ width: `${(currentFrame / totalFrames) * 100}%` }} />
      </ProgressBarWrapper>
    </Wrapper>
  );
};

export default SeekBar;

const Wrapper = styled.div`
  flex-grow: 1;
  margin: ${({ theme }) => theme.spacing(0, 1)};
  padding: ${({ theme }) => theme.spacing(0.75, 0)};
  cursor: pointer;
`;

const ProgressBarWrapper = styled.div`
  border-radius: 2px;
  overflow: hidden;
  background-color: rgba(255, 255, 255, 0.3);
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.4);
`;

const ProgressBar = styled.div`
  height: 6px;
  background-color: rgba(85, 142, 220, 0.9);
`;
